import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  Grid, Typography, Radio, Collapse, FormControl,
  RadioGroup, FormControlLabel, Checkbox, Link,
  Button, Paper, CircularProgress,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

import PaymentPlans from "../PaymentPlans.js";
import * as PaymentActions from "../../actions/PaymentActions";
import { updateCartItems } from "../../actions/CartActions";
import StripeInstallmentCheckoutForm from "../PaymentForm/StripeInstallmentCheckoutForm";
import { checkPayPalOrderCapture, formatPrice, createPayPalInstallmentOrder, openNewWindow } from "../../utils";
import { PLATFORM_REDIRECT_URL } from '../../constants';

const styles = (theme) => ({
  paymentType: {
    backgroundColor: "unset !important"
  },
  removePaddingBottom: {
    paddingBottom: "0 !important"
  },
  removePaddingTop: {
    paddingTop: "0 !important"
  },
  payPalPayBtn: {
    margin: "0 0 10px 0",
    height: "3rem"
  },
  tcs: {
    padding: "14px"
  },
  TC: {
    listStyleType: "none",
    padding: "0",
    margin: "0"
  },
  paypal: {
    width: "4.4rem"
  },
  backBtn: {
    height: "3rem",
    fontSize: '1.3rem'
  },
  cardLogoContainer: {
    display: "grid",
    gridTemplateColumns: "max-content max-content max-content",
    gridTemplateRows: "max-content",
    gridGap: "25px",
    paddingBottom: "0 !important"
  },
  visaContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  masterContainer: {
    "& img": {
      width: "3.9em",
    }
  },
  expressContainer: {
    display: "grid",
    gridTemplateRows: "max-content",
    placeContent: "center",
    "& img": {
      width: "2.8em",
    }
  },
});

const PPLabel = withStyles({
  root: {
    display: "grid"
  },
})(Typography);

class InstallmentPaymentForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agreeOne: false,
      agreeTwo: false,

      paymentMethod: 0,

      payPalCaptureStatus: 'PENDING',
    };

    this.interval = null;
    this.payPalCheckoutWindow = null;
    this.onPaymentMethodChange = this.onPaymentMethodChange.bind(this);
    this.hasAgreed = this.hasAgreed.bind(this);
    this.checkPayPalCaptureStatus = this.checkPayPalCaptureStatus.bind(this);
  }

  componentDidUpdate = (prevProps, prevState) => {
    const { payPalCaptureStatus, paymentMethod } = this.state;
    const { payPalCaptureStatus: prevPayPalCaptureStatus, paymentMethod: prevPaymentMethod } = prevState;
    
    const { step, actions } = this.props;
    const { step: prevStep } = prevProps;


    if (step !== prevStep || paymentMethod !== prevPaymentMethod)  {
      this.setState({ agreeOne: false, agreeTwo: false, agreeThree: false });
    }

    if (prevPayPalCaptureStatus === 'PENDING' && payPalCaptureStatus !== 'PENDING') {

      if (payPalCaptureStatus === 'FAILED') {
        actions.openSnackbar('error', 'Payment Failed');
      }
    
      if (payPalCaptureStatus === 'COMPLETED') {
        actions.openSnackbar('success', 'Thank you for your payment. Please wait...');
        setTimeout(() => window.location.replace(PLATFORM_REDIRECT_URL), 2000);
      }
      if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
      actions.setOverlay(false);
    }


  }

  checkPayPalCaptureStatus = async (token) => {
    try {
      const { tokenStatus } = await checkPayPalOrderCapture(token);

      this.setState({ payPalCaptureStatus: tokenStatus });
    } catch (error) {
      this.setState({ payPalCaptureStatus: 'FAILED' });
    }
  }

  hasAgreed = () => {
    const { agreeOne, agreeTwo } = this.state;
    return agreeOne === true && agreeTwo === true;
  }

  onPaymentMethodChange = ({ target }) => this.setState({ paymentMethod: Number(target.value)});


  handlePayPalSinglePayment = async () => {
    const { actions, orderId } = this.props;

    try {
      const { payPalOrder } = await createPayPalInstallmentOrder(orderId);

      if (payPalOrder && Array.isArray(payPalOrder.links) && payPalOrder.status === 'CREATED') {
        const popUpLink = payPalOrder.links.find(({ rel }) => rel === 'approve');
        if (popUpLink) {
          if (this.payPalCheckoutWindow) {
            actions.setOverlay(true);
            this.payPalCheckoutWindow.location = popUpLink.href;
            this.checkPayPalCaptureStatus(payPalOrder.id);
          } else throw new Error('_Failed to open PayPal');
        } else throw new Error('Approve link is missing');
      } else throw new Error('PayPal order creation failed');

    } catch (error) {
      console.error(error);
      actions.setOverlay(false);
      let errorMessage = 'Something went wrong. Please contact us at 03 9018 5438';
      if (error.message && error.message.startsWith('_')) errorMessage = error.message.slice(1);
      actions.openSnackbar('error', errorMessage);
      if (this.payPalCheckoutWindow) this.payPalCheckoutWindow.close();
    } finally {
      actions.setLoading(false);
    }
  }

  handlePayPalPayment = () => {
    const { actions } = this.props;
    if (!this.hasAgreed())
      return actions.openSnackbar('error', 'Please agree to the Terms & Conditions.');
    
    try {
      const result = openNewWindow();
      if (result && result.error) throw new Error(result.error);
      else this.payPalCheckoutWindow = result;

      actions.setLoading(true);

      this.handlePayPalSinglePayment();
    } catch (error) {
      console.error(error);
      actions.setLoading(false);
      let errorMessage = 'Something went wrong. Please contact us at 03 9018 5438';
      if (error.message && error.message.startsWith('_')) errorMessage = error.message.slice(1);
      actions.openSnackbar('error', errorMessage);
    }
  }

  renderCardLogos = () => {
    const { classes } = this.props;
    return (<>
      <div className={classes.visaContainer}>
        <img src="/media/visa.svg" alt="visa-logo"/>
      </div>
      <div className={classes.masterContainer}>
        <img src="/media/master.svg" alt="master-logo"/>
      </div>
      <div className={classes.expressContainer}>
        <img src="/media/amex.svg" alt="express-logo"/>
      </div>
    </>);
  }

  renderTermsAndConditions = () => {
    const { classes } = this.props;
    return (<>
      <Grid item xs={12} style={{ paddingBottom: "0" }}>
        <Typography variant="h6"><strong>Terms &amp; Conditions</strong></Typography>
      </Grid>
      <Grid item xs={12} style={{ paddingTop: "7px" }}>
        <Paper variant="outlined" className={classes.tcs} >
          <ul className={classes.TC}>
            <li>• I understand the agreement I am entering into with Trade View.</li>
            <li>• I understand that some products discussed in the development programs &amp; software are leveraged derivative products and carry a high level of risk to my capital.</li>
            <li>• I understand that I should only risk capital that I can afford to lose. In certain circumstances due to fluctuations in value I may not get back my initial investment amount.</li>
            <li>• I understand that I may not only lose my initial investment but I may also incur a liability to pay a further amount.</li>
            <li>• I understand that leveraged products are only suitable for investors who understand the risks associated with such products and may not be suitable for all investors.</li>
            <li>• I understand that further information relating to the risks associated with Leveraged products are outlined in the Product Disclosure Statement of the product provider.</li>
            <li>• I agree to read and understand this document (Product Disclosure Statement) prior to opening an account with the product provider.</li>
            <li>• I understand that Trade View makes no claim or assurances that I will become a profitable trader once I have completed  the development programs or by using the software .</li>
            <li>• I understand that the  development programs &amp; software are designed to provide me with tools to trade the markets and then I will need to commit extra time and effort into my trading if I desire a specific result which cannot and will not be guaranteed by Trade View.</li>
            <li>• I understand that I may need additional mentoring at a further cost to me if my specific desired result is not achieved once completing the development programs or by using the software.</li>
            <li>• I have been provided the following documents via the website: <Link href="https://www.tradeview.com.au/terms-conditions/" target="_blank">Terms and Conditions</Link>, <Link href="https://www.tradeview.com.au/privacy-policy/" target="_blank">Privacy Policy</Link>, <Link href="https://www.tradeview.com.au/disclaimer/" target="_blank">Disclaimer</Link>, <Link href="https://www.tradeview.com.au/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link></li>
          </ul>
        </Paper>
      </Grid>
    </>);
  }

  

  renderCartList = () => {
    return (
      <>
        <Grid item xs={12} style={{ paddingBottom: "0" }}>
          <Typography variant="h6"><strong>Shopping Cart</strong></Typography>
        </Grid>
        <Grid item xs={12} style={{ paddingTop: "7px" }}>
          <Paper variant="outlined" >
            <PaymentPlans  pageView={true} />
          </Paper>
      </Grid>
      </>
    )
  }

  renderPayPalButtons = () => {
    const { payPalCaptureStatus } = this.state;
    const { classes, loading, actions, installments } = this.props;
    const unpaidInstallment = installments.find(({ paid }) => !paid)

    const onClick = () => {
      if (!unpaidInstallment)
        actions.openSnackbar('error', 'Please add the amount you would like to pay');
    
      if (payPalCaptureStatus !== 'PENDING')
        this.setState({ payPalCaptureStatus: 'PENDING' });
    
      this.handlePayPalPayment();
    }

    return (
      <Button id="pay-pal-installment-pay-button" className={classes.payPalPayBtn} variant="contained" color="primary" fullWidth onClick={onClick} disabled={loading || !unpaidInstallment}>
        {loading ? <Typography variant="h5"> <CircularProgress size={20} />&nbsp;Please Wait...</Typography> : <Typography variant="h5">Pay Now</Typography>}
      </Button>
    );
  }

  renderPayPalCheckboxes = () => {
    const { state, props } = this;
    const { agreeOne, agreeTwo } = state;
    const unpaidInstallment = props.installments.find(({ paid }) => !paid);
    let nextInstallmentStr = unpaidInstallment ? `$${formatPrice(unpaidInstallment.amount)}` : `$0`;

    if (props.owing && unpaidInstallment) {
      nextInstallmentStr += ` (Remaining $${formatPrice(props.owing - unpaidInstallment.amount)})`;
    }

    return (<>
      <Grid item xs={12}>
        <Grid container  direction="column" justify="flex-start" alignItems="stretch">
          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeOne} onChange={({ target }) => this.setState({ agreeOne: target.checked })} name="agreeOne" />}
            label={<Typography variant="body2">I hereby confirm that I have read, understand and agree to be bound by the terms of these documents. <Link href="https://www.tradeview.com.au/terms-conditions/" target="_blank">Terms and Conditions</Link>, <Link href="https://www.tradeview.com.au/privacy-policy/" target="_blank">Privacy Policy</Link>, <Link href="https://www.tradeview.com.au/disclaimer/" target="_blank">Disclaimer</Link>, <Link href="https://www.tradeview.com.au/financial-services-guide/?_ga=2.215575826.440151372.1594595168-1439122008.1594595168" target="_blank">Financial Services Guide</Link></Typography>}
          />

          <FormControlLabel
            control={<Checkbox color="primary" checked={agreeTwo} onChange={(event) => this.setState({ agreeTwo: event.target.checked })} name="agreeTwo" />}
            label={<Typography variant="body2">I understand that <strong>{nextInstallmentStr}</strong> is an installment payment.</Typography>}
          />
        </Grid>
      </Grid>
    </>);
  }

  renderPayPalCheckout = () => {
    const { renderCardLogos, props } = this;
    const { classes } = props;

    return (<Grid container spacing={2}>
      <Grid item xs={12} style={{ paddingTop: "20px" }}>
        {/* <Grid container spacing={2}>{this.renderTermsAndConditions()}</Grid> */}
        <Grid item xs={12} className={classes.cardLogoContainer}>{renderCardLogos()}</Grid>
        <Grid container spacing={2}>{this.renderCartList()}</Grid>
      </Grid>

      {this.renderPayPalCheckboxes()}

      <Grid item xs={12}>{
        this.renderPayPalButtons()
      }</Grid>
    </Grid>)
  }

  renderStripeCheckout = () => {
    const { state, props, generateUserDetails, renderTermsAndConditions, renderCartList } = this;
    const { paymentMethod } = state;
    const { products, installments, coupon, owing, orderId } = props;

    return (
      <StripeInstallmentCheckoutForm {...{
        paymentMethod,
        generateUserDetails,
        renderTermsAndConditions,
        renderCartList,
        products,
        installments,
        coupon,
        owing,
        orderId
      }} />
    );
  }

  render = () => {
    const { state, props, onPaymentMethodChange } = this;
    const { paymentMethod } = state;
    const { classes, actions } = props;

    return (
      <Grid container>
        <Grid item xs={12}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr max-content' }}>
            <Typography variant="h4" gutterBottom><strong>Installment Payment</strong></Typography>
            <Button className={classes.backBtn} variant="contained" color="primary" fullWidth onClick={() => actions.setStep(3)} >Back</Button>
          </div>
          <Typography variant="h6" gutterBottom>Select Payment Method</Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} className={classes.removePaddingBottom}>
              <FormControl component="fieldset" className={classes.paymentType}>
                <RadioGroup row value={paymentMethod} onChange={onPaymentMethodChange}>
                  <FormControlLabel value={0} control={<Radio id="tvi-radio-paypal" color="primary" />} label={<PPLabel><img className={classes.paypal} src="/media/paypal.svg" alt="PayPal Logo" /></PPLabel>} />
                  <FormControlLabel value={1} control={<Radio id="tvi-radio-stripe" color="primary" />} label={<Typography variant="h6">Credit or Debit Card</Typography>} />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} className={classes.removePaddingTop}>
              <Collapse in={paymentMethod === 0}>{this.renderPayPalCheckout()}</Collapse>
              <Collapse in={paymentMethod === 1}>{this.renderStripeCheckout()}</Collapse>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    );
  };
}

InstallmentPaymentForm.propTypes = {};

const mapStateToProps = ({ payment, paymentPlanReducer }) => ({
  loading: payment.loading,
  step: payment.step,
  coupon: paymentPlanReducer.coupon,
  owing: paymentPlanReducer.owing,
  orderId: paymentPlanReducer.orderId,
  installments: paymentPlanReducer.installments,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(PaymentActions, dispatch),
  onUpdateCartItems: (items) => dispatch(updateCartItems(items))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(InstallmentPaymentForm));
